import _ from 'lodash'
import codes from '@/f1/codes'
import reg from '@/f1/reg'
import moment from 'moment-timezone'

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

let default_item = () => {
  return {
    mode_origin : '',
    mode : 0,
    // level : 1, // 향후 사용 고려 될 수 있음
    // policy_id : 0, // 현재 백엔드에서 사용
    severity : -1, // 위험도
    severity_origin : '',
    policy : '',
    is_change : false,
  }
}

// path, paramater 만 지원
export default {
  name: 'RuleCustom',
  props: ['title', 'description', 'example', 'policy_list', 'tooltip', 'is_preview', 'valid'],
  computed: {},
  watch: {
    policy_list() {
      this.policy_list_custom = this.policy_list ? this.policy_list : []
    }
  },
  data: () => {
    return {
      policy_list_custom : [],
      codes,
      item : default_item(),
      moment,
    }
  },
  methods: {
    // 이미 있는 정책 모드 및 위험도 변경도 업데이트 필요
    change(type='mode', p_index, value) {
      console.log(type, p_index, value)

      switch (type) {
        case 'mode':
          if(this.policy_list_custom[p_index].mode_origin === null || this.policy_list_custom[p_index].mode_origin === undefined) {
            this.policy_list_custom[p_index].mode_origin = value
          } else {
            this.item.is_change = this.policy_list_custom[p_index].mode_origin != value;
          }
          this.policy_list_custom[p_index].mode = value
          break;
        case 'severity':
          if(this.item.severity_origin === null || this.item.severity_origin === undefined) {
            this.policy_list_custom[p_index].severity_origin = value
          } else {
            this.item.is_change = this.policy_list_custom[p_index].severity_origin != value;
          }
          this.policy_list_custom[p_index].severity = value
          break;
      }

      // 최근 변경 시각 업데이트
      if(this.item.is_change) {
        if(type == 'severity') { this.policy_list_custom[p_index].last_serverity_updated_at = moment().format('YYYY-MM-DD HH:mm:ss') }
        else if(type == 'mode') { this.policy_list_custom[p_index].last_mode_updated_at = moment().format('YYYY-MM-DD HH:mm:ss') }
      }
      // 저장시 비교를 위해 업데이트
      this.update()

    },
    update() {
      this.$parent.$emit('update', this.policy_list_custom)
      console.log('updated')
    },
    remove(index=-1) {
      if(this.is_exxist()) { return alert(i18n_data._i18n_alert.exist[this.i18n]) }

      if(index < 0) { return alert(i18n_data._i18n_alert.remove_target[this.i18n]) }
      this.policy_list_custom.splice(index, 1)
      this.update()
    },
    append() {
      if(this.is_exxist()) { return alert(i18n_data._i18n_alert.exist[this.i18n]) }

      // console.log('this.policy_list_custom', this.policy_list_custom, this.item.policy)
      if(this.valid) {
        if(this.valid == 'ip' && !reg.ip4.test(this.item.policy)) { return alert(i18n_toastr._i18n_alert.ip_check[this.i18n]) }
        else if(this.valid == 'domain' && !reg.domain.test(this.item.policy)) { return alert(i18n_toastr._i18n_alert.domain_check[this.i18n]) }
      }

      this.policy_list_custom.push(this.item)
      this.item = Object.assign({}, default_item())
      this.update()
    },
    is_exxist() {
      return _.filter((this.policy_list_custom, x => x.policy == this.item.policy.trim())).length > 0
    },
    load() {
      this.policy_list_custom = this.policy_list ? this.policy_list : []
      // _.forEach(this.policy_list_custom, f => {
      //   f.mode_origin = f.mode
      //   f.severity_origin = f.severity
      // })
    }
  },
  created: function() {   console.log('RuleCustom.vue', 'created'); },
  destroyed: function() { console.log('RuleCustom.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleCustom.vue', 'mounted');
    this.load()
  }
}
